export const checkIsDemoPortal = (): boolean => {
  return window.env?.isDemoPortal.value === true;
};

export const areInsightsEnabled = (): boolean => {
  return window.env?.enableInsights.value ?? false;
};
